import { CouponListGrid, CouponUnorderList, OfferImage } from './styled';

export default function Description(props) {
  const { data } = props;
  return (
    <div className="offers">
      <div className="dropdown_coupon_name">
        {Array.isArray(data?.description) ? (
          <CouponListGrid>
            <CouponUnorderList>
              {data?.description?.map((data, index) => {
                return <li key={`description${index}`}>{data}</li>;
              })}
            </CouponUnorderList>

            <OfferImage src={data?.img} alt={data?.name} />
          </CouponListGrid>
        ) : (
          <span className="coupon_description">{data?.description}</span>
        )}
      </div>
    </div>
  );
}
